import { __decorate, __metadata, __param } from "tslib";
import _, { each, isEmpty, find, size, head, tail, map, findIndex, join, } from 'lodash';
import { E_PrivilegeType } from '@/constants/package';
import { dateFormat } from '@/constants/config';
import { getMinMaxDuration, isExpireNowFromNumber, timeNumber2Date } from '@/utils/date';
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { E_PackageTag } from '@/apis/service/PackageApi.types';
let PrivilegeDataService = class PrivilegeDataService {
    constructor(i18n) {
        this.i18n = i18n;
    }
    getPrivilegeList(companyPrivileges, accountPrivileges = []) {
        let trialPrivilegeList = [];
        each(companyPrivileges, companyPrivilege => {
            const { company_privilege_contract_duration_vo_list: durationList, company_privilege_contract_vo_list: privilegeList, account_privilege_id: accounPrivilegeId, package_vo_list: packageVoList, } = companyPrivilege;
            // 没有合同的话 就是 无效的privilege
            if (isEmpty(privilegeList)) {
                return;
            }
            if (isEmpty(durationList)) {
                return;
            }
            let expiredNum = 0;
            const durationListEx = map(durationList, d => {
                const expired = isExpireNowFromNumber(d.end_at);
                if (expired) {
                    expiredNum += 1;
                }
                return {
                    ...d,
                    expired,
                };
            });
            // 如果全部过期也不显示
            if (expiredNum === durationListEx.length) {
                return;
            }
            if (this.isAnonymousOrOpenApiPrivilege(companyPrivilege)) {
                return;
            }
            const id = companyPrivilege.company_privilege_id;
            const accountPrivilege = accountPrivileges.length > 0 && find(accountPrivileges, accountPrivilege => {
                return accountPrivilege.company_privilege_id === id;
            });
            const { mainPackages, subPackages, } = this.splitPackages(packageVoList);
            const newPrivlege = {
                company_privilege_id: id,
                checked: Boolean(accountPrivilege),
                mainPackages,
                subPackages,
                packageVoList,
                accounPrivilegeId,
                duration: getMinMaxDuration(durationList),
                durationList: durationList,
                company_privilege_contract_duration_vo_list: companyPrivilege.company_privilege_contract_duration_vo_list,
                switch: false,
                privilegeList,
                // 没有分配权限的也不予分配
                isAnonymousPrivilege: this.isAnonymousPrivilege(companyPrivilege),
            };
            trialPrivilegeList = [...trialPrivilegeList, newPrivlege];
        });
        return trialPrivilegeList;
    }
    isAnonymousPrivilege(item) {
        const res = findIndex(item.package_vo_list, (pkg) => pkg.package_tag === E_PackageTag.ANONYMOUS) > -1;
        return res;
    }
    isAnonymousOrOpenApiPrivilege(item) {
        const res = findIndex(item.package_vo_list, (pkg) => pkg.package_tag === E_PackageTag.OPEN_API || pkg.package_tag === E_PackageTag.ANONYMOUS) > -1;
        return res;
    }
    splitPackages(packages) {
        let mainPackages = [];
        let subPackages = [];
        if (size(packages) === 0) {
            console.warn('empty packages:', packages);
            return {
                mainPackages,
                subPackages,
            };
        }
        let findit = false;
        each(packages, pkg => {
            // 优先Base
            if (pkg.package_tag === E_PackageTag.BASE && !findit) {
                findit = true;
                mainPackages.push(pkg);
            }
            else {
                subPackages.push(pkg);
            }
        });
        if (findit) {
            return {
                mainPackages,
                subPackages,
            };
        }
        mainPackages = [];
        subPackages = [];
        each(packages, pkg => {
            // 再次 SUB_INDEPENDENT
            if (pkg.package_tag === E_PackageTag.SUB_INDEPENDENT && !findit) {
                findit = true;
                mainPackages.push(pkg);
            }
            else {
                subPackages.push(pkg);
            }
        });
        if (findit) {
            return {
                mainPackages,
                subPackages,
            };
        }
        // 没有base 没有 SUB_INDEPENDENT
        mainPackages = [head(packages)]; // 直接切割
        subPackages = tail(packages);
        return {
            mainPackages,
            subPackages,
        };
    }
    processPrivileges(privilege_pojo_list, withExpired = false) {
        const res = [];
        each(privilege_pojo_list, ppl => {
            const { packages, contracts, privilege_id, begin_at, end_at, company_privilege_id, account_privilege_id, } = ppl;
            if (company_privilege_id) {
                // 公司权限
                // 过期不显示
                if (isEmpty(contracts)) {
                    return;
                }
                const duration = getMinMaxDuration(contracts, dateFormat);
                let concurrency = 0;
                for (let i = 0; i < contracts.length; i++) {
                    if (contracts[i].concurrency && contracts[i].concurrency > 0) {
                        concurrency = contracts[i].concurrency;
                        break;
                    }
                }
                const business_package_enabled = _.some(contracts, c => c.business_package_enabled);
                const { mainPackages, subPackages } = this.splitPackages(packages);
                if (end_at || begin_at) {
                    let expired = false;
                    if (end_at) {
                        expired = isExpireNowFromNumber(end_at);
                        if (expired && !withExpired) {
                            return;
                        }
                    }
                    else {
                        expired = isExpireNowFromNumber(duration.end_at);
                        if (expired && !withExpired) {
                            return;
                        }
                    }
                    const beginAtTime = begin_at ? timeNumber2Date(begin_at, dateFormat) : duration.begin_at_show;
                    const endAtTime = end_at ? timeNumber2Date(end_at, dateFormat) : duration.end_at_show;
                    res.push({
                        beginAtTime: beginAtTime,
                        endAtTime: endAtTime,
                        expired,
                        packages,
                        concurrency,
                        business_package_enabled,
                        contracts,
                        type: E_PrivilegeType.COMPANY,
                        mainPackages,
                        subPackages,
                        account_privilege_id,
                    });
                }
                else {
                    const { begin_at_show, end_at, end_at_show, } = duration;
                    const expired = isExpireNowFromNumber(end_at);
                    if (expired && !withExpired) {
                        return;
                    }
                    res.push({
                        beginAtTime: begin_at_show,
                        endAtTime: end_at_show,
                        expired,
                        packages,
                        concurrency,
                        contracts,
                        business_package_enabled,
                        type: E_PrivilegeType.COMPANY,
                        mainPackages,
                        subPackages,
                        account_privilege_id,
                    });
                }
            }
            else if (privilege_id) {
                // 用户权限
                // 过期不显示
                const expired = isExpireNowFromNumber(end_at);
                const { mainPackages, subPackages } = this.splitPackages(packages);
                if (expired && !withExpired) {
                    return;
                }
                res.push({
                    beginAtTime: timeNumber2Date(begin_at, dateFormat),
                    endAtTime: timeNumber2Date(end_at, dateFormat),
                    expired,
                    packages,
                    concurrency: 0,
                    type: E_PrivilegeType.TRIAL,
                    mainPackages,
                    subPackages,
                    account_privilege_id,
                });
            }
        });
        return res;
    }
    processAllPrivileges(privilege_pojo_list, withExpired = false) {
        const res = [];
        each(privilege_pojo_list, ppl => {
            const { packages, contracts, privilege_id, begin_at, end_at, company_privilege_id, account_privilege_id, } = ppl;
            if (company_privilege_id) {
                // 公司权限
                // 过期不显示
                if (isEmpty(contracts)) {
                    return;
                }
                const duration = getMinMaxDuration(contracts, dateFormat);
                let concurrency = 0;
                for (let i = 0; i < contracts.length; i++) {
                    if (contracts[i].concurrency && contracts[i].concurrency > 0) {
                        concurrency = contracts[i].concurrency;
                        break;
                    }
                }
                const business_package_enabled = _.some(contracts, c => c.business_package_enabled);
                const { mainPackages, subPackages } = this.splitPackages(packages);
                let expired = false;
                if (end_at) {
                    expired = isExpireNowFromNumber(end_at);
                    if (expired && !withExpired) {
                        return;
                    }
                }
                else {
                    expired = isExpireNowFromNumber(duration.end_at);
                    if (expired && !withExpired) {
                        return;
                    }
                }
                const beginAtTime = begin_at ? timeNumber2Date(begin_at, dateFormat) : duration.begin_at_show;
                const endAtTime = end_at ? timeNumber2Date(end_at, dateFormat) : duration.end_at_show;
                let durations = _.compact(_.map(contracts, c => {
                    const { begin_at: contractBeginAt, end_at: contractEndAt } = c;
                    // 如果 contract.begin_at < 外层end_at 且 contract.end_at > 外层end_at，
                    // 则把该 contract 的 end_at 改为外层的 end_at 来显示
                    let finalEndAt = contractEndAt;
                    if (end_at && contractBeginAt && contractEndAt &&
                        contractBeginAt < end_at && contractEndAt > end_at) {
                        finalEndAt = end_at;
                    }
                    // 如果外层end_at处于中间位置，且contract完全超出外层权限范围，则不显示
                    if (end_at && contractBeginAt && contractEndAt &&
                        contractBeginAt >= end_at && contractEndAt > end_at) {
                        return null;
                    }
                    const durationEndAtTime = finalEndAt ? timeNumber2Date(finalEndAt, dateFormat) : duration.end_at_show;
                    return {
                        begin_at: contractBeginAt,
                        end_at: finalEndAt,
                        beginAtTime: contractBeginAt ? timeNumber2Date(contractBeginAt, dateFormat) : duration.begin_at_show,
                        endAtTime: durationEndAtTime,
                        expired: expired || isExpireNowFromNumber(finalEndAt),
                    };
                }));
                if (!withExpired) {
                    durations = _.filter(durations, d => !isExpireNowFromNumber(d.end_at));
                }
                res.push({
                    beginAtTime: beginAtTime,
                    endAtTime: endAtTime,
                    expired,
                    packages,
                    concurrency,
                    business_package_enabled,
                    contracts,
                    type: E_PrivilegeType.COMPANY,
                    mainPackages,
                    subPackages,
                    account_privilege_id,
                    company_privilege_id,
                    durations,
                });
            }
            else if (privilege_id) {
                // 用户权限
                // 过期不显示
                const expired = isExpireNowFromNumber(end_at);
                const { mainPackages, subPackages } = this.splitPackages(packages);
                if (expired && !withExpired) {
                    return;
                }
                const durations = [{
                        begin_at,
                        end_at,
                        beginAtTime: timeNumber2Date(begin_at, dateFormat),
                        endAtTime: timeNumber2Date(end_at, dateFormat),
                        expired: isExpireNowFromNumber(end_at),
                    }];
                res.push({
                    beginAtTime: timeNumber2Date(begin_at, dateFormat),
                    endAtTime: timeNumber2Date(end_at, dateFormat),
                    durations,
                    expired,
                    packages,
                    concurrency: 0,
                    type: E_PrivilegeType.TRIAL,
                    mainPackages,
                    subPackages,
                    account_privilege_id,
                    privilege_id: privilege_id,
                });
            }
        });
        const privilege_group = _.groupBy(res, (el) => {
            return el.privilege_id || el.company_privilege_id;
        });
        const privilegeRenderList = [];
        _.forEach(privilege_group, (value, key) => {
            const { mainPackages, subPackages, contracts, privilege_id, company_privilege_id } = value[0];
            privilegeRenderList.push({
                key: privilege_id || company_privilege_id,
                mainPackages: mainPackages,
                subPackages: subPackages,
                contracts: contracts,
                list: value,
            });
        });
        return privilegeRenderList;
    }
    getPackageName(pkg) {
        if (pkg) {
            if (this.i18n.locale === 'cn') {
                return pkg.package_name;
            }
            return pkg.en_name;
        }
        return '-';
    }
    getSubPackagesText(subPackages) {
        return join(map(subPackages, item => this.getPackageName(item)), this.i18n.t('backoffice.common.comma'));
    }
};
PrivilegeDataService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object])
], PrivilegeDataService);
export { PrivilegeDataService };
